module.exports = __webpack_public_path__ + "img/stone_grey_ba_detail_rsh.424643a8.jpg";